module.exports = __webpack_public_path__ + "static/img/coupon_empty.7a9b837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/coupon_empty.png
// module id = VK0j
// module chunks = 0